export default{
    __bsi_SeeAll:"登录查看全部"
}